import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpenseManager from './components/ExpenseManager';

const ExpensesPage = ({ user }) => {
    const { tripId } = useParams();
    const navigate = useNavigate();
    const userId = user?.pu_id || null;

    return (
        <Box sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(`/trip/${tripId}`)}
                    size="small"
                    sx={{ color: '#fff' }}
                >
                    Back to Trip
                </Button>
            </Box>
            <ExpenseManager tripId={parseInt(tripId)} userId={userId} user={user} />
        </Box>
    );
};

export default ExpensesPage;
